<template>
  <div class="Abnormal">
    <card-m
      :title="title"
      cardWidth="100%"
      cardHeight="100%"
      maxHeight="unset"
      toolWidth="70%"
      toolJustifyontent="flex-start"
      :show-filter="false"
      :show-export="true"
      :show-column-edit="true"
      export-file-name="异常信息列表"
      @export="handleExport"
      @edit-column="openColumnEdit"
    >
      <!-- ✅ 返回主页：放卡片右上角工具栏，和「更多」并排（不会互相遮挡） -->
      <template slot="card-tool">
        <el-button size="mini" type="primary" plain @click="backHome">返回主页</el-button>
      </template>

      <template slot="card-box">
        <card-table
          tableID="abnormalTable"
          :key="tableRenderKey"
          :total="totalCounts"
          :currentPage="currentPage"
          @sizeChange="handleSizeChanges"
          @currentChange="handleCurrentChanges"

          :mobileColumns="mobileColumnEditFilter"

          :tableColumn="effectiveVisibleColumns"
          :tableData="abnormalData"
          style="height: 100%;"
          :showIndex="true"
          :loading="loading"
          :showPaging="true"
          :size="pageSize"
          @column-filter-change="onColumnFilterChange"
          :columnFilterValues="columnFilterValues"
          @column-width-change="onColumnWidthChange"
          
        >
        </card-table>
      </template>

    </card-m>

    <!-- 列编辑弹窗 -->
    <column-edit-dialog
      :visible.sync="columnEditVisible"
      :columns="tempOrderedColumns"
      :defaultColumns="effectiveDefaultColumnDefs"
      :title="columnEditTitle"
      :dialogWidth="columnEditDialogWidth"
      @confirm="handleColumnSave"
      @cancel="handleColumnCancel"
    />
  </div>
</template>

<script>
import { getAbnormalList } from '@/api/mainapi.js';
import columnEditMixin from '@/mixins/columnEditMixin';
import ColumnEditDialog from '@/components/ColumnEditDialog.vue';
import UserInfoUtils from '@/utils/userInfoUtils.js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

export default {
  name: 'abnormalProgress',
  mixins: [columnEditMixin],
  components: { ColumnEditDialog },
  props: {
    title: {
      type: String,
      default: '异常信息'
    }
  },
  data() {
    return {
      // 列偏好页面标识（mixin 需要）
      pageType: 'abnormalProgress',

      // 手机端可用列（覆盖 mixin 中的默认空数组）
      mobileColumnFilter: ['项目编号','合同编号','任务号',  '相关节点人', '异常类型', '事件详情', '发生时间'],
      mobileColumnEditFilter: ['项目编号','合同编号','任务号',  '相关节点人', '异常类型', '事件详情', '发生时间',  '是否需要处理', '处理人', '处理时间', '解决时间'],

      abnormalColumns: [
        { prop: '项目编号', label: '项目编号', filterable: true },
        { prop: '合同编号', label: '合同编号', filterable: true },
        { prop: '任务号', label: '任务号', filterable: true },
        { prop: '相关节点人', label: '相关节点人', filterable: true },
        { prop: '异常类型', label: '异常类型', filterable: true },
        { prop: '事件详情', label: '事件详情', filterable: true },
        { prop: '发生时间', label: '发生时间', filterable: true, filterType: 'dateFrom' },
        { prop: '是否需要处理', label: '是否需要处理', filterable: true },
        { prop: '处理人', label: '处理人', filterable: true },
        { prop: '处理时间', label: '处理时间', filterable: true, filterType: 'dateFrom' },
        { prop: '解决时间', label: '解决时间', filterable: true, filterType: 'dateFrom' },
      ],

      // 列筛选关键词（仅对应后端支持的筛选字段）
      taskNoKeyword: '',
      contractNoKeyword: '',
      projectNoKeyword: '',
      operatorKeyword: '',
      timeKeyword: '',
      errTypeKeyword: '',
      errDescribeKeyword: '',
      handleKeyword: '',
      handleNameKeyword: '',
      handleTimeKeyword: '',
      resolveTimeKeyword: '',
      columnFilterValues: {},

      // 分页
      currentPage: 1,
      pageSize: 50,

      // 数据
      abnormalData: [],
      totalCounts: 0,
      loading: false,
    };
  },
  computed: {
    // 供 mixin 使用的列定义
    baseColumnDefs() {
      return this.abnormalColumns;
    }
  },
  async mounted() {
    await this.loadColumnPref();
    this.getAbnormalList();
  },
  methods: {
    /** 返回主页：按权限决定目标页（无模块权限 → /homepage 空框架页） */
    backHome() {
      this.$router.push(UserInfoUtils.getDefaultHomeRoute());
    },
    /** 获取异常列表 */
    async getAbnormalList() {
      this.loading = true;

      const params = {
        taskNo: this.taskNoKeyword || '',
        contractNo: this.contractNoKeyword || '',
        projectNo: this.projectNoKeyword || '',
        operator: this.operatorKeyword || '',
        time: this.timeKeyword || '',
        errType: this.errTypeKeyword || '',
        errDescribe: this.errDescribeKeyword || '',
        handle: this.handleKeyword || '',
        handleName: this.handleNameKeyword || '',
        handleTime: this.handleTimeKeyword || '',
        resolveTime: this.resolveTimeKeyword || '',
        pageNo: String(this.currentPage),
        pageSize: String(this.pageSize)
      };

      try {
        const res = await getAbnormalList(params);
        this.loading = false;

        if (res.data.code === 200) {
          const result = res.data.data;
          this.abnormalData = this.processAbnormalData(result['异常信息'] || []);
          this.totalCounts = result['总条数'] || 0;
        } else {
          this.$message.error(res.data.message || '获取数据失败');
        }
      } catch (error) {
        this.loading = false;
        this.$message.error('网络错误，请检查连接');
      }
    },

    /** 处理异常数据 */
    processAbnormalData(data) {
      if (!Array.isArray(data)) return [];
      return data.map(item => ({
        项目编号: item['项目编号'] || '',
        合同编号: item['合同编号'] || '',
        任务号: item['任务号'] || '',
        相关节点人: item['相关节点人'] || '',
        异常类型: item['异常类型'] || '',
        事件详情: item['事件详情'] || '',
        发生时间: item['发生时间'] ? item['发生时间'].substring(0, 10) : '',
        是否需要处理: item['是否需要处理'] || '',
        处理人: item['处理人'] || '',
        处理时间: item['处理时间']  ? item['处理时间'].substring(0, 10) : '',
        解决时间: item['解决时间']  ? item['解决时间'].substring(0, 10) : '',
      }));
    },

    /** 列筛选变化 */
    onColumnFilterChange(filterValues) {
      this.taskNoKeyword = filterValues['任务号'] || '';
      this.contractNoKeyword = filterValues['合同编号'] || '';
      this.projectNoKeyword = filterValues['项目编号'] || '';
      this.operatorKeyword = filterValues['相关节点人'] || '';
      this.timeKeyword = filterValues['发生时间'] || '';
      this.errTypeKeyword = filterValues['异常类型'] || '';
      this.errDescribeKeyword = filterValues['事件详情'] || '';
      this.handleKeyword = filterValues['是否需要处理'] || '';
      this.handleNameKeyword = filterValues['处理人'] || '';
      this.handleTimeKeyword = filterValues['处理时间'] || '';
      this.resolveTimeKeyword = filterValues['解决时间'] || '';
      this.columnFilterValues = filterValues;
      this.currentPage = 1;
      this.tableRenderKey++;
      this.getAbnormalList();
    },

    /** 改变每页条数 */
    handleSizeChanges(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.tableRenderKey++;
      this.getAbnormalList();
    },

    /** 改变页码 */
    handleCurrentChanges(val) {
      this.currentPage = val;
      this.getAbnormalList();
    },

    /** 导出Excel */
    handleExport() {
      const xlsxParam = { raw: true };
      const wb = XLSX.utils.table_to_book(
        document.querySelector('#abnormalTable'),
        xlsxParam
      );
      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '异常信息列表.xlsx'
        );
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout);
        }
      }
      return wbout;
    }
  }
};
</script>

<style scoped lang="scss">
.Abnormal {
  width: 100%;
  height: calc(100vh - 65px);
  display: flex;
  flex-direction: column;
}

::v-deep .card-m {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

::v-deep .card-box {
  flex: 1;
  min-height: 0;
  overflow-y: hidden;
  overflow-x: hidden;
}

/* 手机端 */
@media (max-width: 768px) {
  .Abnormal {
    height: calc(100vh - 50px);
  }
}
</style>
